import API_BASE_URL from '../config/api';
import '../css/station-mode.css';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
	registerInfo,
	updateDistanceOffset,
	updateCategoryOffset
} from '../actions/index';

import {
	CombinadaSprint,
	Pedestrismo,
	competitionList,
	PedestrismoBackup
} from '../constants/enums';

import {
	PageHeader,
	Form,
	Grid,
	Row,
	Checkbox,
	Col,
	Button,
	FormGroup,
	FormControl,
	ControlLabel
} from '../../node_modules/react-bootstrap/lib/';

import ReactDOM from 'react-dom';

import axios from 'axios';


export class RaceConfigForm extends Component {

	// competition {1: pedestrismo, 3: rural bike, 4: combinada sprint, 5: combinada simple}
	constructor(props) {

		super(props);


		this.handleFormSubmit =
			this.handleFormSubmit.bind(this);

		this.handleFormSubmitOnCloud =
			this.handleFormSubmitOnCloud.bind(this);

		this.handleChange =
			this.handleChange.bind(this);

		this.handleChangeOnCloud =
			this.handleChangeOnCloud.bind(this);

		this.handleChecked =
			this.handleChecked.bind(this);

		this.handleStartOffsetChange =
			this.handleStartOffsetChange.bind(this);

		this.handleCategoryStartOffsetChange =
			this.handleCategoryStartOffsetChange.bind(this);


		this.state = {

			interval: 10,

			events: [],

			eventID: 0,

			competition: 0,

			caption:
				'Distancia 1 es obligatorio',

			sendButton:
				'Guardar Cambios',

			sendButtonOnCloud:
				'Cargar',

			selectedEventID: 0,

			now: 0,

			bsStyle: 'primary',

			name: '',

			participantList: [],

			date: '',

			place: '',


			/*
			 * ==========================
			 * DISTANCIA 1
			 * ==========================
			 */

			distance1Type: '',

			distance1Value: 0,

			distance1StartOffset: 0,


			/*
			 * ==========================
			 * DISTANCIA 2
			 * ==========================
			 */

			distance2Type: '',

			distance2Value: 0,

			distance2StartOffset: 0,


			/*
			 * ==========================
			 * DISTANCIA 3
			 * ==========================
			 */

			distance3Type: '',

			distance3Value: 0,

			distance3StartOffset: 0,


			/*
			 * ==========================
			 * OFFSETS POR CATEGORIA
			 * ==========================
			 *
			 * Utilizado por:
			 *
			 * - Triatlón
			 * - Duatlón
			 * - Rural Bike / MTB
			 *
			 * Estructura:
			 *
			 * [
			 *     {
			 *         catCod: 'CAB PRO',
			 *         catName: 'CPRO',
			 *         offset: 0
			 *     }
			 * ]
			 */

			categoryStartOffsets: [],


			sendSMS: false,

			showResultsDistance1: false,

			showResultsLocales: false,

			prefix: '',

			beep: true
		};
	}


	getProperty(
		participant,
		property
	) {

		return participant[property];
	}


	/*
	 * -------------------------------------------------------
	 * DETERMINA SI LA COMPETENCIA USA LARGADAS POR CATEGORIA
	 * -------------------------------------------------------
	 *
	 * Pedestrismo y PedestrismoBackup utilizan distancias.
	 *
	 * El resto de las competencias utiliza catCod.
	 */
	usesCategoryStartOffsets(
		competition = this.state.competition
	) {

		return (
			Number(competition) !==
				Number(Pedestrismo)
			&&
			Number(competition) !==
				Number(PedestrismoBackup)
			&&
			Number(competition) !== 0
		);
	}


	/*
	 * -------------------------------------------------------
	 * OBTENER CATEGORIAS DEL PADRON
	 * -------------------------------------------------------
	 *
	 * Generamos una lista única utilizando catCod.
	 *
	 * catCod es la clave.
	 * catName es solamente descriptivo.
	 */
	getParticipantCategories() {

		const participantList =
			Array.isArray(
				this.props.participantList
			)
				? this.props.participantList
				: [];


		const categoryMap =
			new Map();


		participantList.forEach(
			(participant) => {

				const catCod =
					String(
						participant.catCod || ''
					).trim();


				const catName =
					String(
						participant.catName || ''
					).trim();


				if (
					catCod === ''
				) {

					return;
				}


				if (
					!categoryMap.has(
						catCod
					)
				) {

					categoryMap.set(
						catCod,
						{
							catCod:
								catCod,

							catName:
								catName !== ''
									? catName
									: catCod
						}
					);
				}
			}
		);


		return Array.from(
			categoryMap.values()
		)
			.sort(
				(a, b) => {

					return String(
						a.catCod
					).localeCompare(
						String(
							b.catCod
						),
						'es',
						{
							numeric: true,
							sensitivity: 'base'
						}
					);
				}
			);
	}


	/*
	 * -------------------------------------------------------
	 * SINCRONIZAR CATEGORIAS
	 * -------------------------------------------------------
	 *
	 * Conserva los offsets ya configurados.
	 *
	 * Si aparece una categoría nueva,
	 * comienza con offset 0.
	 */
	syncCategoryStartOffsets() {

		const categories =
			this.getParticipantCategories();


		this.setState(
			(prevState) => {

				const previousOffsets =
					Array.isArray(
						prevState.categoryStartOffsets
					)
						? prevState.categoryStartOffsets
						: [];


				const previousMap =
					new Map();


				previousOffsets.forEach(
					(item) => {

						const catCod =
							String(
								item.catCod || ''
							).trim();


						if (
							catCod !== ''
						) {

							previousMap.set(
								catCod,
								item
							);
						}
					}
				);


				const categoryStartOffsets =
					categories.map(
						(category) => {

							const previous =
								previousMap.get(
									category.catCod
								);


							return {
								catCod:
									category.catCod,

								catName:
									category.catName,

								offset:
									previous
										? Number(
											previous.offset || 0
										)
										: 0
							};
						}
					);


				return {
					categoryStartOffsets:
						categoryStartOffsets
				};
			}
		);
	}


	handleChecked(
		e,
		input
	) {

		switch (
			input
		) {
			case 'backupStation':
				if (this.state.competition === Pedestrismo || this.state.competition === PedestrismoBackup) {
					this.setState({
						competition: e.target.checked ? PedestrismoBackup : Pedestrismo,
						bsStyle: 'primary'
					});
				}
				break;

			case 'sendSMS':

				this.setState({
					sendSMS:
						e.target.checked
				});

				break;


			case 'beep':

				this.setState({
					beep:
						e.target.checked
				});

				break;


			case 'showResultsDistance1':

				this.setState({
					showResultsDistance1:
						e.target.checked
				});

				break;


			case 'showResultsLocales':

				this.setState({
					showResultsLocales:
						e.target.checked
				});

				break;


			default:

				break;
		}
	}


	/*
	 * -------------------------------------------------------
	 * CAMBIO DE OFFSET POR DISTANCIA
	 * -------------------------------------------------------
	 *
	 * Utilizado por Pedestrismo.
	 *
	 * offset es expresado en MINUTOS.
	 *
	 * Si ya existen tiempos registrados,
	 * updateDistanceOffset recalibra todos
	 * los atletas de esa distancia.
	 */
	handleStartOffsetChange(
		e,
		distanceNumber
	) {

		const rawValue =
			e.target.value;


		const newOffset =
			rawValue === ''
				? 0
				: Number(
					rawValue
				);


		if (
			Number.isNaN(
				newOffset
			)
		) {

			return;
		}


		let offsetProperty;

		let distanceProperty;


		switch (
			distanceNumber
		) {

			case 1:

				offsetProperty =
					'distance1StartOffset';

				distanceProperty =
					'distance1Type';

				break;


			case 2:

				offsetProperty =
					'distance2StartOffset';

				distanceProperty =
					'distance2Type';

				break;


			case 3:

				offsetProperty =
					'distance3StartOffset';

				distanceProperty =
					'distance3Type';

				break;


			default:

				return;
		}


		const previousOffset =
			Number(
				this.state[
					offsetProperty
				] || 0
			);


		const distance =
			String(
				this.state[
					distanceProperty
				] || ''
			).trim();


		const deltaMinutes =
			newOffset -
			previousOffset;


		if (
			distance !== '' &&
			deltaMinutes !== 0
		) {

			this.props.updateDistanceOffset(
				distance,
				deltaMinutes
			);
		}


		this.setState({
			[offsetProperty]:
				newOffset
		});
	}


	/*
	 * -------------------------------------------------------
	 * CAMBIO DE OFFSET POR CATEGORIA
	 * -------------------------------------------------------
	 *
	 * Utilizado por:
	 *
	 * - Triatlón
	 * - Duatlón
	 * - Rural Bike / MTB
	 *
	 * Recalibra los tiempos ya existentes
	 * de todos los atletas del catCod.
	 */
	handleCategoryStartOffsetChange(
		e,
		catCod
	) {

		const rawValue =
			e.target.value;


		const newOffset =
			rawValue === ''
				? 0
				: Number(
					rawValue
				);


		if (
			Number.isNaN(
				newOffset
			)
		) {

			return;
		}


		const normalizedCatCod =
			String(
				catCod || ''
			).trim();


		if (
			normalizedCatCod === ''
		) {

			return;
		}


		const currentConfig =
			(
				this.state.categoryStartOffsets ||
				[]
			)
				.find(
					(category) => {

						return (
							String(
								category.catCod || ''
							).trim() ===
							normalizedCatCod
						);
					}
				);


		const previousOffset =
			currentConfig
				? Number(
					currentConfig.offset || 0
				)
				: 0;


		const deltaMinutes =
			newOffset -
			previousOffset;


		if (
			deltaMinutes !== 0
		) {

			this.props.updateCategoryOffset(
				normalizedCatCod,
				deltaMinutes
			);
		}


		this.setState(
			(prevState) => {

				return {

					categoryStartOffsets:
						(
							prevState.categoryStartOffsets ||
							[]
						)
							.map(
								(category) => {

									if (
										String(
											category.catCod || ''
										).trim() !==
										normalizedCatCod
									) {

										return category;
									}


									return {
										...category,

										offset:
											newOffset
									};
								}
							)
				};
			}
		);
	}


	handleChange(
		e,
		input
	) {

		const value =
			e.target.value;


		/*
		 * Conservamos el comportamiento
		 * histórico al presionar ENTER.
		 */
		if (
			e.key === 'Enter'
		) {

			setTimeout(
				() => {

					this.props.registerInfo(

						this.state.name,

						null,

						this.state.competition,


						this.state.distance1Type,

						this.state.distance1Value,

						this.state.distance1StartOffset,


						this.state.distance2Type,

						this.state.distance2Value,

						this.state.distance2StartOffset,


						this.state.distance3Type,

						this.state.distance3Value,

						this.state.distance3StartOffset,


						this.state.showResultsDistance1,

						this.state.showResultsLocales,

						this.state.date,

						this.state.place,

						this.state.sendSMS,

						this.state.beep,

						this.state.interval,

						this.state.prefix,


						/*
						 * NUEVO:
						 * offsets por categoría.
						 */
						this.state.categoryStartOffsets
					);

				},
				1
			);


			return;
		}


		switch (
			input
		) {

			case 'name':

				this.setState({
					name:
						value
				});

				break;


			case 'date':

				this.setState({
					date:
						value
				});

				break;


			case 'distance1':

				this.setState({

					distance1Type:
						ReactDOM.findDOMNode(
							this.select1
						).value,

					distance1Value:
						value
				});

				break;


			case 'distance2':

				this.setState({

					distance2Type:
						ReactDOM.findDOMNode(
							this.select2
						).value,

					distance2Value:
						value
				});

				break;


			case 'distance3':

				this.setState({

					distance3Type:
						ReactDOM.findDOMNode(
							this.select3
						).value,

					distance3Value:
						value
				});

				break;


			case 'place':

				this.setState({
					place:
						value
				});

				break;


			case 'interval':

				this.setState({
					interval:
						value
				});

				break;


			case 'competition': {

				const competition =
					parseInt(
						ReactDOM.findDOMNode(
							this.select
						).value,
						10
					);


				this.setState(
					{
						competition:
							competition
					},
					() => {

						if (
							this.usesCategoryStartOffsets(
								competition
							)
						) {

							this.syncCategoryStartOffsets();
						}
					}
				);

				break;
			}


			case 'prefix':

				this.setState({
					prefix:
						value
				});

				break;


			case 'showResultsDistance1':

				this.setState({
					showResultsDistance1:
						value
				});

				break;


			case 'showResultsLocales':

				this.setState({
					showResultsLocales:
						value
				});

				break;


			default:

				break;
		}
	}


	handleChangeOnCloud(
		e,
		input
	) {

		const value =
			e.target.value;


		switch (
			input
		) {

			case 'event':

				this.setState({
					selectedEventID:
						value
				});

				break;


			default:

				break;
		}
	}


componentDidMount() {

	/*
	 * =====================================================
	 * RECUPERAR CONFIGURACION DESDE REDUX
	 * =====================================================
	 *
	 * Si la aplicación fue restaurada desde localStorage,
	 * reducerRegisterInfo ya contiene los datos del evento.
	 *
	 * RaceConfigForm utiliza state local para renderizar
	 * los campos, por lo tanto copiamos aquí los datos
	 * recuperados desde Redux.
	 */
	if (
		this.props.eventID &&
		Number(
			this.props.eventID
		) > 0
	) {

		this.setState({

			eventID:
				this.props.eventID || 0,

			selectedEventID:
				this.props.eventID || 0,

			name:
				this.props.name || '',

			competition:
				Number(
					this.props.competition || 0
				),

			date:
				this.props.date || '',

			place:
				this.props.place || '',


			/*
			 * DISTANCIA 1
			 */
			distance1Type:
				this.props.distance1Type || '',

			distance1Value:
				Number(
					this.props.distance1Value || 0
				),

			distance1StartOffset:
				Number(
					this.props.distance1StartOffset || 0
				),


			/*
			 * DISTANCIA 2
			 */
			distance2Type:
				this.props.distance2Type || '',

			distance2Value:
				Number(
					this.props.distance2Value || 0
				),

			distance2StartOffset:
				Number(
					this.props.distance2StartOffset || 0
				),


			/*
			 * DISTANCIA 3
			 */
			distance3Type:
				this.props.distance3Type || '',

			distance3Value:
				Number(
					this.props.distance3Value || 0
				),

			distance3StartOffset:
				Number(
					this.props.distance3StartOffset || 0
				),


			/*
			 * OFFSETS POR CATEGORIA
			 */
			categoryStartOffsets:
				Array.isArray(
					this.props.categoryStartOffsets
				)
					? this.props.categoryStartOffsets
					: [],


			showResultsDistance1:
				Boolean(
					this.props.showResultsDistance1
				),

			showResultsLocales:
				Boolean(
					this.props.showResultsLocales
				),

			sendSMS:
				Boolean(
					this.props.sendSMS
				),

			beep:
				this.props.beep !== undefined
					? Boolean(
						this.props.beep
					)
					: true,

			interval:
				this.props.interval !== undefined
					? this.props.interval
					: 10,

			prefix:
				this.props.prefix || ''

		});


		console.log(
			'Configuración del evento recuperada desde Redux:',
			this.props.eventID,
			this.props.name
		);
	}


	/*
	 * =====================================================
	 * OBTENER EVENTOS DISPONIBLES EN CLOUD
	 * =====================================================
	 *
	 * Esto continúa funcionando independientemente
	 * de que hayamos recuperado una carrera local.
	 */
	axios

		.get(
			(API_BASE_URL + '/races/next')
		)

		.then(
			(response) => {

				if (
					response.status === 200
				) {

					const races =
						Array.isArray(
							response.data.races
						)
							? response.data.races
							: [];


					this.setState({

						bsStyle:
							'danger',

						isLoading:
							true,

						label:
							'sucess',

						events:
							races
					});


					/*
					 * Si estamos recuperando una carrera,
					 * NO reemplazamos selectedEventID
					 * con el primer evento de /races/next.
					 */
					if (
						!(
							this.props.eventID &&
							Number(
								this.props.eventID
							) > 0
						)
						&&
						races.length > 0
					) {

						this.setState({

							selectedEventID:
								races[0].id
						});
					}


				} else {

					this.setState({

						bsStyle:
							'danger',

						isLoading:
							false,

						label:
							'Error'
					});
				}
			}
		)

		.catch(
			(error) => {

				console.error(
					'Error obteniendo eventos disponibles:',
					error
				);


				this.setState({

					isLoading:
						false
				});
			}
		);
}

	/*
	 * -------------------------------------------------------
	 * ACTUALIZAR CATEGORIAS CUANDO CAMBIA participantList
	 * -------------------------------------------------------
	 *
	 * Esto es importante porque al cargar una carrera Cloud
	 * el padrón puede llegar después que la configuración
	 * general del evento.
	 */
	componentDidUpdate(
		prevProps
	) {

		if (
			prevProps.participantList !==
			this.props.participantList
			&&
			this.usesCategoryStartOffsets()
		) {

			this.syncCategoryStartOffsets();
		}
	}


	handleFormSubmit(
		e
	) {

		e.preventDefault();


		const isPedestrianCompetition =

			this.state.competition ===
				Pedestrismo
			||
			this.state.competition ===
				PedestrismoBackup;


		const validDistance1 =

			this.state.distance1Type !== ''
			&&
			Number(
				this.state.distance1Value
			) > 0;


		if (
			(
				validDistance1 &&
				isPedestrianCompetition
			)
			||
			!isPedestrianCompetition
		) {

			this.setState({
				bsStyle:
					'success'
			});
		}


		/*
		 * IMPORTANTE:
		 *
		 * La firma debe coincidir exactamente
		 * con registerInfo de actions/index.js.
		 */
		setTimeout(
			() => {

				this.props.registerInfo(

					this.state.name,

					this.state.eventID,

					this.state.competition,


					this.state.distance1Type,

					this.state.distance1Value,

					this.state.distance1StartOffset,


					this.state.distance2Type,

					this.state.distance2Value,

					this.state.distance2StartOffset,


					this.state.distance3Type,

					this.state.distance3Value,

					this.state.distance3StartOffset,


					this.state.showResultsDistance1,

					this.state.showResultsLocales,

					this.state.date,

					this.state.place,

					this.state.sendSMS,

					this.state.beep,

					this.state.interval,

					this.state.prefix,


					/*
					 * NUEVO:
					 * offsets por categoría.
					 */
					this.state.categoryStartOffsets
				);

			},
			1
		);


		const racename =
			this.state.name;


		const place =
			this.state.place;


		const competition =
			this.state.competition;


		const interval =
			this.state.interval;


		const distance1Type =
			this.state.distance1Type;


		const distance2Type =
			this.state.distance2Type;


		const distance3Type =
			this.state.distance3Type;

	}


	handleFormSubmitOnCloud(
		e
	) {

		e.preventDefault();


		this.setState({

			bsStyle:
				'warning',

			isLoading:
				true,

			label:
				'Cargando'
		});


		axios

			.get(
				(API_BASE_URL + '/races/') +
				this.state.selectedEventID
			)

			.then(
				(response) => {

					if (
						response.status === 200
					) {

						const race =
							response.data.race || {};


						/*
						 * Distancias:
						 *
						 * Solamente son utilizadas para
						 * configurar largadas de Pedestrismo.
						 *
						 * Para Triatlón / Duatlón /
						 * Rural Bike se utilizan categorías.
						 */
						const distances =
							Array.isArray(
								race.distances
							)

								? race.distances

									.filter(
										(distance) => {

											const length =
												Number(
													distance.length
												);


											const meters =
												Number(
													distance.meters
												);


											return (

												distance.is_competitive ===
													true

												&&

												!Number.isNaN(
													length
												)

												&&

												length > 0

												&&

												!Number.isNaN(
													meters
												)

												&&

												meters > 0
											);
										}
									)

									.sort(
										(
											distanceA,
											distanceB
										) => {

											return (

												Number(
													distanceA.meters
												)

												-

												Number(
													distanceB.meters
												)
											);
										}
									)

								: [];


						const distance1 =
							distances[0] || null;


						const distance2 =
							distances[1] || null;


						const distance3 =
							distances[2] || null;


						console.log(
							'Distancias competitivas ordenadas:',
							distances
						);


						const loadedCompetition = Number(race.race_type || 0);
                        const competition = loadedCompetition === Pedestrismo
                          && this.state.competition === PedestrismoBackup
                          ? PedestrismoBackup : loadedCompetition;


						this.setState(
							{

								bsStyle:
									'warning',

								isLoading:
									false,

								label:
									'Cargado',


								name:
									race.name || '',


								competition:
									competition,


								date:
									race.start_at
										? race.start_at.substring(
											0,
											10
										)
										: '',


								place:
									race.City &&
									race.City.name

										? race.City.name

										: '',


								eventID:
									race.id,


								/*
								 * Pedestrismo continúa
								 * utilizando estas distancias.
								 */
								distance1Type:
									distance1
										? String(
											distance1.length
										)
										: '',


								distance1Value:
									distance1
										? Number(
											distance1.meters
										)
										: 0,


								distance1StartOffset:
									0,


								distance2Type:
									distance2
										? String(
											distance2.length
										)
										: '',


								distance2Value:
									distance2
										? Number(
											distance2.meters
										)
										: 0,


								distance2StartOffset:
									0,


								distance3Type:
									distance3
										? String(
											distance3.length
										)
										: '',


								distance3Value:
									distance3
										? Number(
											distance3.meters
										)
										: 0,


								distance3StartOffset:
									0,


								/*
								 * Cada vez que cargamos una carrera
								 * nueva reiniciamos la configuración
								 * de categorías.
								 *
								 * Luego syncCategoryStartOffsets()
								 * las obtiene del participantList.
								 */
								categoryStartOffsets:
									[]
							},
							() => {

								if (
									this.usesCategoryStartOffsets(
										competition
									)
								) {

									this.syncCategoryStartOffsets();
								}
							}
						);


					} else {

						this.setState({

							bsStyle:
								'danger',

							isLoading:
								false,

							label:
								'Error'
						});
					}
				}
			)

			.catch(
				(error) => {

					console.error(
						'Error al obtener la carrera:',
						error
					);


					this.setState({

						bsStyle:
							'danger',

						isLoading:
							false,

						label:
							'Error'
					});
				}
			);
	}


	renderDistanceOptions() {

		const distances = [

			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			10,
			12,
			14,
			21
		];


		return distances.map(
			(distance) => (

				<option
					key={
						distance
					}
					value={
						String(
							distance
						)
					}
				>

					{
						distance
					}

					K

				</option>
			)
		);
	}


	/*
	 * -------------------------------------------------------
	 * RENDER OFFSETS POR CATEGORIA
	 * -------------------------------------------------------
	 */
	renderCategoryStartOffsets() {

		if (
			!this.usesCategoryStartOffsets()
		) {

			return null;
		}


		const categories =
			Array.isArray(
				this.state.categoryStartOffsets
			)
				? this.state.categoryStartOffsets
				: [];


		if (
			categories.length === 0
		) {

			return (

				<FormGroup>

					<Col
						componentClass={
							ControlLabel
						}
						sm={3}
					>

						Largadas por categoría

					</Col>


					<Col sm={6}>

						<p
							className="form-control-static"
						>
							No hay categorías cargadas.
						</p>

					</Col>

				</FormGroup>
			);
		}


		return (

			<div>

				<FormGroup>

					<Col
						componentClass={
							ControlLabel
						}
						sm={3}
					>

						Largadas por categoría

					</Col>


					<Col sm={6}>

						<p
							className="form-control-static"
						>
							Configure el offset de largada
							en minutos para cada categoría.
						</p>

					</Col>

				</FormGroup>


				{
					categories.map(
						(category) => {

							return (

								<FormGroup
									key={
										category.catCod
									}
									controlId={
										'categoryOffset-' +
										category.catCod
									}
								>

									<Col
										componentClass={
											ControlLabel
										}
										sm={3}
									>

										{
											category.catCod
										}

									</Col>


									<Col sm={3}>

										<FormControl
											type="text"
											value={
												category.catName
											}
											disabled
										/>

									</Col>


									<Col sm={2}>

										<FormControl
											type="number"
											min="0"
											step="1"
											value={
												category.offset
											}
											onChange={
												(e) =>
													this.handleCategoryStartOffsetChange(
														e,
														category.catCod
													)
											}
											placeholder="Offset min."
										/>

									</Col>


									<Col sm={2}>

										<p
											className="form-control-static"
										>
											minutos
										</p>

									</Col>

								</FormGroup>
							);
						}
					)
				}

			</div>
		);
	}


	render() {

		const showPedestrianDistances =

			this.state.competition ===
				Pedestrismo

			||

			this.state.competition ===
				PedestrismoBackup;


		return (

			<Grid>


				<Row className="show-grid">

					<Col xs={8} md={12}>

						<PageHeader>

							<center>
								Evento
							</center>

						</PageHeader>

					</Col>

				</Row>


				<Row className="show-grid">


					{/*
					 * =============================
					 * CARGAR EVENTO CLOUD
					 * =============================
					 */}

					<Form
						horizontal
						onSubmit={
							this.handleFormSubmitOnCloud
						}
					>

						<FormGroup controlId="formEvent">

							<Col
								componentClass={
									ControlLabel
								}
								sm={4}
							>

								Seleccione

							</Col>


							<Col sm={4}>

								<FormControl
									componentClass="select"
									value={
										this.state.selectedEventID
									}
									onChange={
										(e) =>
											this.handleChangeOnCloud(
												e,
												'event'
											)
									}
								>

									{
										this.state.events.map(
											(
												event,
												index
											) => (

												<option
													key={
														index
													}
													value={
														event.id
													}
												>

													{
														event.id
													}

													{' - '}

													{
														event.name
													}

												</option>
											)
										)
									}

								</FormControl>

							</Col>


							<Col sm={4}>

								<Button className={this.state.competition === PedestrismoBackup ? 'btn-backup' : ''}
									bsStyle={this.state.competition === PedestrismoBackup ? 'danger' : this.state.bsStyle}
									type="submit"
								>

									{
										this.state.sendButtonOnCloud
									}

								</Button>

							</Col>

						</FormGroup>

					</Form>


					<hr />


					<Col xs={8} md={12}>

						<Form
							horizontal
							onSubmit={
								this.handleFormSubmit
							}
						>


							{/*
							 * =============================
							 * NOMBRE
							 * =============================
							 */}

							<FormGroup controlId="formHorizontalName">

								<Col
									componentClass={
										ControlLabel
									}
									sm={3}
								>

									Nombre

								</Col>


								<Col sm={6}>

									<FormControl
										type="text"
										onChange={
											(e) =>
												this.handleChange(
													e,
													'name'
												)
										}
										value={
											this.state.name
										}
										placeholder="Nombre..."
									/>

								</Col>

							</FormGroup>


							{/*
							 * =============================
							 * TIPO
							 * =============================
							 */}

							<FormGroup
								controlId="formHorizontalCompetition"
								validationState="error"
							>

								<Col
									componentClass={
										ControlLabel
									}
									sm={3}
								>

									Tipo

								</Col>


								<Col sm={3}>

									<FormControl
										ref={
											(select) => {
												this.select =
													select;
											}
										}
										componentClass="select"
										value={
											String(this.state.competition === PedestrismoBackup ? Pedestrismo : this.state.competition)
										}
										onChange={
											(e) =>
												this.handleChange(
													e,
													'competition'
												)
										}
									>

										<option value="0">
											Elija el tipo de evento
										</option>


										{
											Object.keys(
												competitionList
											)

												.sort(
													(
														a,
														b
													) =>
														Number(a) -
														Number(b)
												)

												.map(
													(key) => (

														<option
															key={
																key
															}
															value={
																key
															}
														>

															{
																competitionList[
																	key
																]
															}

														</option>
													)
												)
										}

									</FormControl>

								</Col>

							<Col sm={6}>
                  <Checkbox checked={this.state.competition === PedestrismoBackup}
                    disabled={!showPedestrianDistances}
                    onChange={event => this.handleChecked(event, 'backupStation')}>
                    Estación Backup
                  </Checkbox>
                </Col>

                </FormGroup>


							{/*
							 * =============================
							 * DISTANCIA 1
							 * =============================
							 */}

							<FormGroup
								hidden={
									!showPedestrianDistances
								}
								controlId="formHorizontalDistance1"
								validationState="error"
							>

								<Col
									componentClass={
										ControlLabel
									}
									sm={3}
								>

									Distancia 1 (más corta)

								</Col>


								<Col sm={2} md={1}>

									<FormControl
										ref={
											(select) => {
												this.select1 =
													select;
											}
										}
										componentClass="select"
										value={
											String(
												this.state.distance1Type
											)
										}
										onChange={
											(e) =>
												this.setState({
													distance1Type:
														e.target.value
												})
										}
									>

										<option value="">
											Seleccione
										</option>

										{
											this.renderDistanceOptions()
										}

									</FormControl>

								</Col>


								<Col sm={2} md={2}>

									<FormControl
										type="number"
										min="0"
										onChange={
											(e) =>
												this.handleChange(
													e,
													'distance1'
												)
										}
										value={
											this.state.distance1Value
										}
										placeholder="Metros..."
									/>

								</Col>


								<Col sm={2} md={2}>

									<FormControl
										type="number"
										min="0"
										step="1"
										onChange={
											(e) =>
												this.handleStartOffsetChange(
													e,
													1
												)
										}
										value={
											this.state
												.distance1StartOffset
										}
										placeholder="Offset min."
									/>

								</Col>


								<Col sm={2} md={3}>

									<FormGroup controlId="formShowDistance1Results">

										<Col sm={12}>

											<Checkbox
												checked={
													this.state
														.showResultsDistance1
												}
												onChange={
													(e) =>
														this.handleChecked(
															e,
															'showResultsDistance1'
														)
												}
											>

												Premiación por categorías

											</Checkbox>

										</Col>

									</FormGroup>

								</Col>

							</FormGroup>


							{/*
							 * =============================
							 * DISTANCIA 2
							 * =============================
							 */}

							<FormGroup
								hidden={
									!showPedestrianDistances
								}
								controlId="formHorizontalDistance2"
								validationState="warning"
							>

								<Col
									componentClass={
										ControlLabel
									}
									sm={3}
								>

									Distancia 2

								</Col>


								<Col sm={2} md={1}>

									<FormControl
										ref={
											(select) => {
												this.select2 =
													select;
											}
										}
										componentClass="select"
										value={
											String(
												this.state.distance2Type
											)
										}
										onChange={
											(e) =>
												this.setState({
													distance2Type:
														e.target.value
												})
										}
									>

										<option value="">
											Seleccione
										</option>

										{
											this.renderDistanceOptions()
										}

									</FormControl>

								</Col>


								<Col sm={2}>

									<FormControl
										type="number"
										min="0"
										onChange={
											(e) =>
												this.handleChange(
													e,
													'distance2'
												)
										}
										value={
											this.state.distance2Value
										}
										placeholder="Distancia en metros..."
									/>

								</Col>


								<Col sm={2} md={2}>

									<FormControl
										type="number"
										min="0"
										step="1"
										onChange={
											(e) =>
												this.handleStartOffsetChange(
													e,
													2
												)
										}
										value={
											this.state
												.distance2StartOffset
										}
										placeholder="Offset min."
									/>

								</Col>


								<Col sm={2} md={3}>

									<FormGroup controlId="formShowDistance2Results">

										<Col sm={12}>

											<Checkbox
												checked={true}
												disabled
											>

												Premiación general y categorías

											</Checkbox>

										</Col>

									</FormGroup>

								</Col>

							</FormGroup>


							{/*
							 * =============================
							 * DISTANCIA 3
							 * =============================
							 */}

							<FormGroup
								hidden={
									!showPedestrianDistances
								}
								controlId="formHorizontalDistance3"
								validationState="warning"
							>

								<Col
									componentClass={
										ControlLabel
									}
									sm={3}
								>

									Distancia 3

								</Col>


								<Col sm={2} md={1}>

									<FormControl
										ref={
											(select) => {
												this.select3 =
													select;
											}
										}
										componentClass="select"
										value={
											String(
												this.state.distance3Type
											)
										}
										onChange={
											(e) =>
												this.setState({
													distance3Type:
														e.target.value
												})
										}
									>

										<option value="">
											Seleccione
										</option>

										{
											this.renderDistanceOptions()
										}

									</FormControl>

								</Col>


								<Col sm={2}>

									<FormControl
										type="number"
										min="0"
										onChange={
											(e) =>
												this.handleChange(
													e,
													'distance3'
												)
										}
										value={
											this.state.distance3Value
										}
										placeholder="Distancia en metros..."
									/>

								</Col>


								<Col sm={2} md={2}>

									<FormControl
										type="number"
										min="0"
										step="1"
										onChange={
											(e) =>
												this.handleStartOffsetChange(
													e,
													3
												)
										}
										value={
											this.state
												.distance3StartOffset
										}
										placeholder="Offset min."
									/>

								</Col>


								<Col sm={2} md={3}>

									<FormGroup controlId="formShowDistance3Results">

										<Col sm={12}>

											<Checkbox
												checked={true}
												disabled
											>

												Premiación general y categorías

											</Checkbox>

										</Col>

									</FormGroup>

								</Col>

							</FormGroup>


							{/*
							 * =============================
							 * LARGADAS POR CATEGORIA
							 * =============================
							 *
							 * Solo aparece para competencias
							 * distintas de Pedestrismo.
							 */}

							{
								this.renderCategoryStartOffsets()
							}


							{/*
							 * =============================
							 * CIUDAD
							 * =============================
							 */}

							<FormGroup controlId="formHorizontalPlace">

								<Col
									componentClass={
										ControlLabel
									}
									sm={3}
								>

									Ciudad

								</Col>


								<Col sm={3}>

									<FormControl
										type="text"
										onChange={
											(e) =>
												this.handleChange(
													e,
													'place'
												)
										}
										value={
											this.state.place
										}
										placeholder="Ciudad..."
									/>

								</Col>


								<Col sm={3}>

									<Checkbox
										checked={
											this.state
												.showResultsLocales
										}
										onChange={
											(e) =>
												this.handleChecked(
													e,
													'showResultsLocales'
												)
										}
									>

										Premiación locales

									</Checkbox>

								</Col>

							</FormGroup>


							{/*
							 * =============================
							 * FECHA
							 * =============================
							 */}

							<FormGroup controlId="formHorizontalDate">

								<Col
									componentClass={
										ControlLabel
									}
									sm={3}
								>

									Fecha

								</Col>


								<Col sm={6}>

									<FormControl
										type="date"
										onChange={
											(e) =>
												this.handleChange(
													e,
													'date'
												)
										}
										value={
											this.state.date
										}
									/>

								</Col>

							</FormGroup>


							{/*
							 * =============================
							 * PAUSA
							 * =============================
							 */}

							<FormGroup controlId="formHorizontalInterval">

								<Col
									componentClass={
										ControlLabel
									}
									sm={3}
								>

									Pausa

								</Col>


								<Col sm={6}>

									<FormControl
										type="number"
										onChange={
											(e) =>
												this.handleChange(
													e,
													'interval'
												)
										}
										value={
											this.state.interval
										}
										placeholder="Pausa en segundos..."
									/>

								</Col>

							</FormGroup>


							{/*
							 * =============================
							 * SMS
							 * =============================
							 */}

							<FormGroup controlId="formHorizontalSendSMS">

								<Col
									componentClass={
										ControlLabel
									}
									sm={3}
								>

									Enviar SMS

								</Col>


								<Col sm={6}>

									<Checkbox
										checked={
											this.state.sendSMS
										}
										onChange={
											(e) =>
												this.handleChecked(
													e,
													'sendSMS'
												)
										}
									/>

								</Col>

							</FormGroup>


							<FormGroup controlId="formHorizontalPrefix">

								<Col
									componentClass={
										ControlLabel
									}
									sm={3}
								>

									Prefijo SMS

								</Col>


								<Col sm={6}>

									<FormControl
										type="text"
										onChange={
											(e) =>
												this.handleChange(
													e,
													'prefix'
												)
										}
										value={
											this.state.prefix
										}
										placeholder="Felicitaciones "
									/>

								</Col>

							</FormGroup>


							{/*
							 * =============================
							 * BEEP
							 * =============================
							 */}

							<FormGroup controlId="formHorizontalBeep">

								<Col
									componentClass={
										ControlLabel
									}
									sm={3}
								>

									Beep

								</Col>


								<Col sm={6}>

									<Checkbox
										checked={
											this.state.beep
										}
										onChange={
											(e) =>
												this.handleChecked(
													e,
													'beep'
												)
										}
									/>

								</Col>

							</FormGroup>


							<hr />


							<FormGroup>

								<Col
									smOffset={3}
									md={9}
								>

									<Button className={this.state.competition === PedestrismoBackup ? 'btn-backup' : ''}
										bsStyle={this.state.competition === PedestrismoBackup ? 'danger' : this.state.bsStyle}
										type="submit"
									>

										{
											this.state.sendButton
										}

									</Button>

								</Col>

							</FormGroup>


						</Form>

					</Col>

				</Row>

			</Grid>
		);
	}
}


function mapDispatchToProps(
	dispatch
) {

	return bindActionCreators(
		{
			registerInfo,
			updateDistanceOffset,
			updateCategoryOffset
		},
		dispatch
	);
}


function mapStateToProps(
	state
) {

	const {
		participantList
	} =
		state.reducerRegisterTime;


	const {
		name,
		eventID,
		competition,

		distance1Type,
		distance1Value,
		distance1StartOffset,

		distance2Type,
		distance2Value,
		distance2StartOffset,

		distance3Type,
		distance3Value,
		distance3StartOffset,

		categoryStartOffsets,

		showResultsDistance1,
		showResultsLocales,

		date,
		place,

		sendSMS,
		beep,
		interval,
		prefix
	} =
		state.reducerRegisterInfo;


	const {
		startedAt,
		stoppedAt,
		canStart
	} =
		state.reducerTimer;


	return {

		participantList,

		name,
		eventID,
		competition,

		distance1Type,
		distance1Value,
		distance1StartOffset,

		distance2Type,
		distance2Value,
		distance2StartOffset,

		distance3Type,
		distance3Value,
		distance3StartOffset,

		categoryStartOffsets,

		showResultsDistance1,
		showResultsLocales,

		date,
		place,

		sendSMS,
		beep,
		interval,
		prefix,

		startedAt,
		stoppedAt,
		canStart
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	RaceConfigForm
);



// WEBPACK FOOTER //
// ./src/containers/race-config-form.js